// Utility to format price with Indian commas (e.g., 10000000 → 1,00,00,000)
export function formatINRPrice(price) {
  if (price == null || isNaN(Number(price))) return price;
  return Number(price).toLocaleString('en-IN');
}

// Human-readable display formatting according to requirements:
// - < ₹1,00,000 : show in Thousands (₹10,000 -> "₹10 Thousand")
// - ₹1,00,000 - ₹99,99,999 : show in Lakhs + Thousand (₹8,50,000 -> "₹8 Lakhs 50 Thousand")
// - ≥ ₹1,00,00,000 : show in Crores + Lakhs (₹2,80,00,000 -> "₹2 Cr 80 Lakhs")
export function formatDisplayPrice(price) {
  if (price == null || isNaN(Number(price))) return price;
  const p = Math.floor(Number(price));

  if (p < 100000) {
    const thousands = Math.round(p / 1000);
    return `₹${thousands} Thousand`;
  }

  if (p < 10000000) {
    const lakhs = Math.floor(p / 100000);
    const rem = p % 100000;
    const thousands = Math.round(rem / 1000);
    if (thousands > 0) return `₹${lakhs} Lakhs ${thousands} Thousand`;
    return `₹${lakhs} Lakhs`;
  }

  // >= 1 Crore
  const crores = Math.floor(p / 10000000);
  const rem = p % 10000000;
  const lakhs = Math.round(rem / 100000);
  if (lakhs > 0) return `₹${crores} Cr ${lakhs} Lakhs`;
  return `₹${crores} Cr`;
}
